import { fetchApi, fetchVoid } from "../club-api/internal";
import {
	domainCheckSchema,
	type VenueId,
	venueDomainSchema,
	venueDomainsSchema,
} from "../schemas/venue";

const post = (body?: unknown): RequestInit => ({
	...(body === undefined
		? {}
		: { body: JSON.stringify(body), headers: { "Content-Type": "application/json" } }),
	method: "POST",
});

const domainPath = (venueId: VenueId, host: string) =>
	`/venues/${venueId}/domains/${encodeURIComponent(host)}`;

export const venueDomainsApi = {
	/** Claim a host; it stays pending until DNS points at the target. */
	claim: (venueId: VenueId, host: string) =>
		fetchApi(`/venues/${venueId}/domains`, venueDomainSchema, post({ host })),
	list: (venueId: VenueId) => fetchApi(`/venues/${venueId}/domains`, venueDomainsSchema),
	remove: (venueId: VenueId, host: string) =>
		fetchVoid(domainPath(venueId, host), { method: "DELETE" }),
	/** Look the host up now; only a host that points at the target becomes verified. */
	verify: (venueId: VenueId, host: string) =>
		fetchApi(`${domainPath(venueId, host)}/verify`, domainCheckSchema, post()),
};
